import React, {useEffect} from 'react';
import styles from './AcercaDe.module.css'; // Importa los estilos
import mision from './images/mision.webp'; // Ajusta la ruta si es necesario
import vision from './images/vision.webp'; // Ajusta la ruta si es necesario
import fondo from './images/Fondo.mp4'; // Ajusta la ruta si es necesario
import Footer from '../Home/Footer/Footer';

const AcercaDe = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <div className={styles.videoContainer}>
                <video className={styles.videoBackground} autoPlay loop muted playsInline>
                    <source src={fondo} type="video/mp4" />
                    Tu navegador no soporta el elemento de video.
                </video>
                <div className={styles.overlay}></div>
            </div>
            <div className={styles.section}>
                <div className={styles.TituloSeccion}>
                    Conoce más de Nosotros
                </div> 
                <div className={styles.row}>
                    <div className={styles.column}>
                        <img src={mision} alt="Imagen que representa la misión empresarial" />
                    </div>
                    <div className={styles.column}>
                        <h2>Misión Empresarial</h2>
                        <p>Impulsar la revolución empresarial mediante soluciones avanzadas de inteligencia 
                            artificial que catalicen un proceso de mejora continua, elevando la calidad y 
                            eficiencia de productos y servicios, y preparando a las empresas 
                            para el futuro.</p>
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={styles.column}>
                        <h2>Visión Empresarial</h2>
                        <p>Posicionarnos como líderes en la transformación de industrias 
                            mediante la inteligencia artificial, estableciendo estándares 
                            de excelencia y eficiencia mediante un compromiso constante 
                            con la mejora continua y cambiando el mundo para mejor.</p>
                    </div>
                    <div className={styles.column}>
                        <img src={vision} alt="Imagen que representa la visión empresarial" />
                    </div>
                </div>

                <div className={styles.row}>
                    <div className={styles.column}>
                        <h2>Nuestra Historia</h2> 
                        <p className="nuestra-historia">En el corazón de Ecuador, bajo el vasto cielo de Quito, dos visionarios, 
                            apasionados por el inmenso potencial de la matemática y la inteligencia 
                            artificial, decidieron transformar el futuro tecnológico de su país. 
                            Profesores en dos de las más prestigiosas universidades del país, la 
                            Pontificia Universidad Católica del Ecuador (PUCE) y la Escuela Politécnica 
                            Nacional (EPN), estos pioneros compartían más que su profesión: un 
                            sueño común por el progreso humano y la innovación tecnológica.</p>
                            
                        <p>Fue así como, en enero de 2024, con la determinación de quienes saben 
                            que están a punto de cambiar el mundo, comenzaron a dedicar cada fin de 
                            semana al desarrollo de tecnologías avanzadas. Su objetivo era claro: 
                            facilitar la incorporación de soluciones de inteligencia artificial 
                            personalizadas que respondieran a las necesidades específicas de cada 
                            cliente.
                            Lo que comenzó como un equipo de dos entusiastas rápidamente creció 
                            hasta convertirse, en abril del mismo año, en un vibrante grupo de ocho 
                            innovadores. Cada semana, nuestro equipo trabaja incansablemente en el 
                            diseño de nuevas soluciones, impulsando a las empresas hacia la nueva era de
                            la inteligencia artificial.</p>
                          
                        <p>En nuestra empresa, no solo innovamos; redefinimos el futuro. 
                            Con cada proyecto y con cada solución, acercamos a las organizaciones 
                            a un horizonte donde la tecnología y la humanidad convergen armoniosamente. 
                            Nuestra misión es clara: ser los arquitectos de la revolución tecnológica, 
                            guiando a las empresas a través de la complejidad de la IA con simplicidad 
                            y precisión magistrales.
                            Unimos pasión, matemáticas y AI para crear un mañana donde todos prosperemos.
                            Bienvenidos a la vanguardia de la tecnología, bienvenidos a Relatividad IA.</p>

                    </div>
                </div>
            </div>
            <div className={styles.footer}>
                <Footer />
            </div>
        </>
    );
}

export default AcercaDe;
